import { PublishType } from 'src/components/ProductPublishModal/types';

interface PublishTypeLabels {
  title: string;
  description: string;
}

const publishTypeLabels: Record<PublishType, PublishTypeLabels> = {
  [PublishType.PRODUCT]: { title: 'Product Publish', description: 'Product data' },
  [PublishType.PRICING]: { title: 'Pricing Publish', description: 'Pricing data' },
};

export const getPublishTypeLabel = (type: PublishType): PublishTypeLabels =>
  publishTypeLabels[type] ?? { title: '', description: '' };
